import React from "react";

import classnames from "classnames";

import "intl";
import "intl/locale-data/jsonp/en.js";

let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});

const PriceExplanation = ({ currentPlan, coupon, period }) => {
    let { price: originalPrice } = currentPlan;
    let discountPrice, discountDuration, originalPriceDisplay;

    let amount_off, duration, code, duration_in_months, percent_off;

    let afterDiscount = (
        <span className="after-discount-ends">
            Then you will be charged{" "}
            <span className="pro-full-cost">
                {formatter.format(originalPrice)}
            </span>{" "}
            <span className="month-year-interval">{period}</span> after your
            discount period ends until you cancel your subscription.
        </span>
    );
    if (coupon) {
        ({
            amount_off,
            duration,
            code,
            duration_in_months,
            percent_off
        } = coupon);
        if (coupon.percent_off) {
            discountPrice =
                originalPrice - (originalPrice * coupon.percent_off) / 100;
        } else if (coupon.amount_off) {
            discountPrice = originalPrice - coupon.amount_off / 100;
        }
        if (discountPrice < 0) {
            discountPrice = 0;
        }
        discountPrice = ` ${formatter.format(discountPrice)}`;
        originalPriceDisplay = (
            <span className="cost-full">{formatter.format(originalPrice)}</span>
        );

        switch (duration) {
            case "once":
                discountDuration =
                    "Your discount will expire after your next payment";
                break;
            case "repeating":
                discountDuration = `Your discount will expire in ${duration_in_months} month${
                    duration_in_months > 1 ? "s" : null
                }`;
                break;
            case "forever":
                discountDuration = "Your discount will last forever";
                afterDiscount = null;
                break;
        }
        discountDuration = (
            <span className="coupon-duration">
                {discountDuration}
                <br />
            </span>
        );
    } else {
        originalPriceDisplay = formatter.format(originalPrice);
    }

    let classes = classnames("price-status", {
        "has-coupon": !!coupon
    });

    let chargedDescription;
    if (coupon) {
        chargedDescription = (
            <p className="when-you-are-billed-discount">
                {discountDuration}
                {afterDiscount}
            </p>
        );
    } else {
        chargedDescription = (
            <p className="when-you-are-billed">
                You will be charged now and{" "}
                <span className="month-year-interval">{period}</span> at this
                time when your account automatically renews. Cancel automatic
                renewal at any time.
            </p>
        );
    }

    return (
        <React.Fragment>
            <div className={classes}>
                Total billed today <span id="dash" />{" "}
                <span className="cost-total">
                    {originalPriceDisplay}
                    {discountPrice}
                </span>
            </div>

            {chargedDescription}
        </React.Fragment>
    );
};

export default PriceExplanation;
